import i18 from "i18next"

import Backend from "i18next-xhr-backend"

import LanguageDetector from "i18next-browser-languagedetector"

import { initReactI18next } from "react-i18next"

const i18next = i18

  .use(Backend)

  .use(LanguageDetector)

  .use(initReactI18next)

  .init({
    fallbackLng: "en-US",

    debug: false,

    interpolation: {
      escapeValue: false,

      formatSeparator: ","
    },

    backend: {
      loadPath: `${process.env.PUBLIC_URL}/assets/data/locales/{{lng}}.json`
    }
  })

export default i18next
